import { FC } from 'react';
import { Title } from 'atoms/Typography/Typography';
import { useProductDetailInfo } from 'pages/ProductDetail/hooks/useProductDetailInfo';
import { renderRichText } from 'modules/stroyblok/services';
import { ReactMarkdown } from '../Markdown';
import styles from './WarrantyInfo.module.css';

export const WarrantyInfo: FC = () => {
  const { warrantyInfoTitle, warrantyInfoText } = useProductDetailInfo();
  return (
    <div className={styles.info}>
      <Title type="md" className={styles.heading}>
        {warrantyInfoTitle}
      </Title>
      <ReactMarkdown
        text={renderRichText(warrantyInfoText) || ''}
        className={styles.text}
      />
    </div>
  );
};
